<template>
  <!-- sidebar mobile -->
  <div
    @click="toggleSidebar"
    class="xl:hidden bg-black opacity-50 z-50 inset-0 fixed transition-opacity"
    :class="isSidebarOpen ? 'block ease-in' : 'hidden ease-out'"
  ></div>
  <Sidebar
    :toggleSideBar="toggleSidebar"
    v-on:closeClick="toggleSidebar"
    :primaryLinks="primaryLinks"
    :productLinks="productLinks"
    class="xl:hidden transform xl:translate-x-0 xl:static xl:inset-auto"
    :class="
      isSidebarOpen
        ? 'translate-x-0 ease-out transition-transform'
        : '-translate-x-full ease-in transition-transform'
    "
  />
  <!-- full navbar -->
  <div
    v-if="$route.name !== 'become author' && $route.name !== 'checkout'"
    class="flex-shrink-0 bg-gray-900 fixed top-0 w-full z-40 shadow"
    :class="
      $route.name === 'login' ||
      $route.name === 'register' ||
      routeType === 'forgotPassword'
        ? 'py-2 px-2 md:p-0'
        : 'py-0 px-0'
    "
  >
    <!-- navigation header -->
    <nav
      class="relative max-w-1xl mx-auto flex items-center justify-between"
      :class="
        routeType === 'General' ||
        routeType === 'Product by category' ||
        routeType === 'All Items' ||
        routeType === 'single product'
          ? 'md:p-6 2xl:px-0 p-4'
          : 'p-4'
      "
    >
      <div
        class="flex items-center"
        :class="
          $route.name === 'login' ||
          $route.name === 'register' ||
          routeType === 'forgotPassword'
            ? 'p-2 2xl:px-2'
            : 'py-0 2xl:px-0'
        "
      >
        <!-- nav open icon -->
        <button
          @click="toggleSidebar"
          class="mr-4 xl:hidden block focus:text-white text-gray-300 focus:outline-none"
        >
          <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"
            />
          </svg>
        </button>

        <!-- logo -->
        <div class="cursor-pointer">
          <a href="/">
            <svg class="h-5 md:h-6" viewBox="0 0 128 28" fill="none">
              <path
                d="M1.12351 7.92756C1.42136 7.92756 1.70702 8.05187 1.9177 8.27316C2.12838 8.49445 2.24683 8.79462 2.24702 9.10767V10.008H2.29983C2.35337 9.8204 2.49179 9.58595 2.71509 9.30461C2.96449 8.99815 3.25241 8.72878 3.57093 8.50393C3.95235 8.23292 4.3658 8.01539 4.80078 7.85685C5.30404 7.6735 5.83372 7.5832 6.36632 7.58995C7.31114 7.58995 8.10452 7.79601 8.74645 8.20814C9.38839 8.62027 9.91458 9.23871 10.325 10.0635C10.7058 9.27004 11.3128 8.6214 12.0613 8.20814C12.7595 7.80998 13.54 7.59772 14.3343 7.58995C15.3149 7.58995 16.1174 7.75876 16.742 8.09637C17.3324 8.40183 17.839 8.8603 18.2142 9.42855C18.5775 9.99794 18.8278 10.6386 18.9499 11.312C19.085 12.0294 19.1521 12.7592 19.1503 13.4905V20.0518C19.1507 20.2091 19.1216 20.3649 19.0647 20.5104C19.0078 20.6558 18.9242 20.7881 18.8186 20.8995C18.7131 21.011 18.5877 21.0996 18.4496 21.1601C18.3115 21.2207 18.1634 21.2521 18.0138 21.2525H17.8857C17.5835 21.2525 17.2937 21.1263 17.08 20.9017C16.8664 20.6771 16.7463 20.3725 16.7463 20.0549V13.8312C16.7472 13.342 16.7158 12.8535 16.6523 12.3689C16.6005 11.934 16.4688 11.5139 16.2645 11.1318C16.0659 10.7735 15.7796 10.4776 15.4354 10.2749C15.0785 10.0599 14.6061 9.9522 14.0182 9.95169C12.8607 9.95169 12.0314 10.3263 11.5303 11.0755C11.0292 11.8248 10.7789 12.7899 10.7793 13.9711V20.0541C10.7793 20.3717 10.6593 20.6763 10.4456 20.9009C10.2319 21.1255 9.9421 21.2517 9.63991 21.2517H9.51186C9.20966 21.2517 8.91985 21.1255 8.70616 20.9009C8.49248 20.6763 8.37243 20.3717 8.37243 20.0541V14.2805C8.37556 13.6981 8.34415 13.1161 8.27839 12.5377C8.22991 12.0648 8.10308 11.6044 7.90364 11.1774C7.72444 10.8025 7.44579 10.49 7.10134 10.2779C6.75312 10.063 6.28505 9.95524 5.69713 9.95473C5.26971 9.95455 4.84667 10.0453 4.45353 10.2216C4.05022 10.402 3.69034 10.6748 3.40019 11.02C3.07361 11.4182 2.82748 11.8821 2.67675 12.3834C2.4983 12.9359 2.40907 13.5871 2.40907 14.3368V20.0549C2.40907 20.2123 2.37953 20.3682 2.32213 20.5137C2.26474 20.6591 2.18061 20.7913 2.07458 20.9025C1.96854 21.0137 1.84267 21.1019 1.70418 21.162C1.56569 21.222 1.41729 21.2528 1.26748 21.2525H1.13943C0.837232 21.2525 0.547414 21.1263 0.33373 20.9017C0.120046 20.6771 0 20.3725 0 20.0549L0 9.10539C0.000575063 8.79267 0.119221 8.49297 0.329879 8.27213C0.540537 8.05129 0.825979 7.92736 1.12351 7.92756V7.92756Z"
                fill="white"
              />
              <path
                d="M20.0105 14.5903C20.0033 13.6528 20.1809 12.7239 20.5321 11.8621C20.8707 11.033 21.3564 10.2792 21.9631 9.641C23.2381 8.31667 24.9583 7.57397 26.7509 7.57397C28.5434 7.57397 30.2637 8.31667 31.5386 9.641C32.1451 10.2794 32.6307 11.0332 32.9696 11.8621C33.3207 12.7234 33.4982 13.6518 33.4912 14.5888C33.496 15.5108 33.3257 16.4245 32.9903 17.2765C32.6549 18.1284 32.1611 18.9014 31.5379 19.5503C30.9211 20.1853 30.1948 20.6911 29.398 21.0406C27.7013 21.7716 25.799 21.7716 24.1023 21.0406C23.3054 20.6913 22.5791 20.1855 21.9624 19.5503C21.3391 18.9014 20.8454 18.1284 20.51 17.2765C20.1746 16.4245 20.0043 15.5108 20.0091 14.5888L20.0105 14.5903ZM22.5788 14.5903C22.5725 15.2265 22.6719 15.859 22.8725 16.4593C23.0513 17.0009 23.3334 17.4985 23.7015 17.9215C24.0699 18.3332 24.5165 18.6589 25.0124 18.8773C26.1285 19.3458 27.3732 19.3458 28.4893 18.8773C28.9851 18.6586 29.4317 18.333 29.8002 17.9215C30.1678 17.4981 30.4499 17.0007 30.6293 16.4593C31.0209 15.2471 31.0209 13.9328 30.6293 12.7205C30.4497 12.1795 30.1677 11.6824 29.8002 11.2591C29.4317 10.8476 28.9851 10.522 28.4893 10.3033C27.3732 9.83487 26.1285 9.83487 25.0124 10.3033C24.5165 10.5218 24.0699 10.8474 23.7015 11.2591C23.3336 11.682 23.0515 12.1793 22.8725 12.7205C22.6719 13.3211 22.5725 13.9539 22.5788 14.5903V14.5903Z"
                fill="white"
              />
              <path
                d="M34.4193 7.92751V5.28519C34.4193 4.99439 34.5292 4.7155 34.7249 4.50987C34.9205 4.30424 35.1859 4.18872 35.4625 4.18872H35.7838C36.0599 4.18953 36.3244 4.30543 36.5193 4.51099C36.7142 4.71655 36.8235 4.99498 36.8233 5.28519V7.92751H39.231C39.5077 7.92751 39.773 8.04303 39.9686 8.24866C40.1643 8.45429 40.2742 8.73318 40.2742 9.02398C40.274 9.31465 40.164 9.59335 39.9684 9.79881C39.7728 10.0043 39.5075 10.1197 39.231 10.1197H36.8233V16.164C36.8233 16.5396 36.8328 16.9091 36.8501 17.2749C36.8622 17.6124 36.9302 17.9451 37.0512 18.258C37.1613 18.5417 37.3469 18.786 37.5859 18.9614C37.827 19.1393 38.1791 19.2283 38.6421 19.2283C38.9381 19.2273 39.2334 19.199 39.5247 19.1439H39.5341C39.6337 19.1238 39.7362 19.127 39.8344 19.1532C39.9327 19.1795 40.0242 19.2282 40.1025 19.2958C40.1809 19.3635 40.244 19.4484 40.2876 19.5447C40.3311 19.6409 40.354 19.746 40.3545 19.8526V20.6631C40.3545 20.8159 40.308 20.9648 40.2218 21.0879C40.1357 21.211 40.0144 21.3019 39.8756 21.3475C39.669 21.4125 39.4578 21.4598 39.244 21.4889C38.8943 21.5453 38.5415 21.5783 38.1878 21.5877C37.2603 21.5877 36.5427 21.4516 36.0348 21.1794C35.5269 20.9072 35.1524 20.5559 34.9113 20.1255C34.6675 19.6837 34.5211 19.19 34.483 18.6808C34.4386 18.147 34.4164 17.6082 34.4164 17.0642V10.1197"
                fill="white"
              />
              <path
                d="M40.6988 3.14875C40.6961 2.90504 40.7409 2.66332 40.8305 2.43851C40.9201 2.2137 41.0526 2.01057 41.2197 1.84166C41.3821 1.66806 41.5757 1.53017 41.7893 1.43605C42.0028 1.34193 42.2321 1.29346 42.4637 1.29346C42.6953 1.29346 42.9246 1.34193 43.1381 1.43605C43.3517 1.53017 43.5453 1.66806 43.7077 1.84166C43.8749 2.01053 44.0075 2.21364 44.0972 2.43844C44.1869 2.66325 44.2319 2.90499 44.2293 3.14875C44.2317 3.39249 44.1867 3.63418 44.097 3.85896C44.0073 4.08374 43.8748 4.28686 43.7077 4.45585C43.5453 4.62945 43.3517 4.76733 43.1381 4.86145C42.9246 4.95557 42.6953 5.00405 42.4637 5.00405C42.2321 5.00405 42.0028 4.95557 41.7893 4.86145C41.5757 4.76733 41.3821 4.62945 41.2197 4.45585C41.0527 4.28682 40.9203 4.08368 40.8307 3.85889C40.7412 3.63411 40.6963 3.39244 40.6988 3.14875ZM42.3997 7.92774H42.5277C42.8298 7.92774 43.1195 8.05381 43.3332 8.27824C43.5468 8.50267 43.6669 8.80709 43.6671 9.12458V20.055C43.6671 20.3727 43.5471 20.6773 43.3334 20.9019C43.1197 21.1265 42.8299 21.2526 42.5277 21.2526H42.3997C42.0975 21.2526 41.8077 21.1265 41.594 20.9019C41.3803 20.6773 41.2602 20.3727 41.2602 20.055V9.12458C41.2604 8.80709 41.3806 8.50267 41.5942 8.27824C41.8079 8.05381 42.0976 7.92774 42.3997 7.92774V7.92774Z"
                fill="white"
              />
              <path
                d="M44.787 14.5903C44.7798 13.6528 44.9574 12.7239 45.3086 11.8621C45.6472 11.033 46.1329 10.2792 46.7396 9.641C48.0146 8.31667 49.7348 7.57397 51.5274 7.57397C53.3199 7.57397 55.0401 8.31667 56.3151 9.641C56.9216 10.2794 57.4072 11.0332 57.7461 11.8621C58.0971 12.7234 58.2747 13.6518 58.2677 14.5888C58.2725 15.5108 58.1022 16.4245 57.7668 17.2765C57.4314 18.1284 56.9376 18.9014 56.3144 19.5503C55.6977 20.1855 54.9714 20.6913 54.1744 21.0406C52.4777 21.7716 50.5755 21.7716 48.8788 21.0406C48.0818 20.6913 47.3556 20.1855 46.7389 19.5503C46.1156 18.9014 45.6219 18.1284 45.2865 17.2765C44.9511 16.4245 44.7808 15.5108 44.7856 14.5888L44.787 14.5903ZM47.3552 14.5903C47.349 15.2265 47.4484 15.859 47.649 16.4593C47.8278 17.0009 48.1099 17.4985 48.478 17.9215C48.8464 18.3332 49.293 18.6589 49.7889 18.8773C50.905 19.3458 52.1497 19.3458 53.2658 18.8773C53.7615 18.6586 54.2081 18.333 54.5767 17.9215C54.9443 17.4981 55.2263 17.0007 55.4057 16.4593C55.7973 15.2471 55.7973 13.9328 55.4057 12.7205C55.2262 12.1795 54.9441 11.6824 54.5767 11.2591C54.2081 10.8476 53.7615 10.522 53.2658 10.3033C52.1497 9.83487 50.905 9.83487 49.7889 10.3033C49.293 10.5218 48.8464 10.8474 48.478 11.2591C48.1101 11.682 47.828 12.1793 47.649 12.7205C47.4484 13.3211 47.349 13.9539 47.3552 14.5903V14.5903Z"
                fill="white"
              />
              <path
                d="M60.3397 7.92748H60.4685C60.7705 7.92748 61.0602 8.05355 61.2739 8.27798C61.4876 8.50241 61.6077 8.80683 61.6079 9.12432V9.97899H61.6614C61.9638 9.26626 62.4898 8.68989 63.2393 8.24988C63.9888 7.80987 64.8535 7.58987 65.8335 7.58987C66.4289 7.58794 67.0207 7.68758 67.5857 7.8849C68.1333 8.07293 68.6353 8.38433 69.0565 8.79735C69.4971 9.24347 69.8394 9.78567 70.0592 10.3858C70.309 11.0321 70.4339 11.7958 70.4339 12.6768V20.0525C70.4339 20.3701 70.3139 20.6747 70.1002 20.8993C69.8865 21.1239 69.5967 21.2501 69.2945 21.2501H69.1665C68.8643 21.2501 68.5744 21.1239 68.3608 20.8993C68.1471 20.6747 68.027 20.3701 68.027 20.0525V13.3824C68.027 12.7645 67.9467 12.235 67.7861 11.794C67.6496 11.3913 67.4306 11.025 67.1444 10.7211C66.883 10.4538 66.5674 10.2521 66.2213 10.1311C65.8714 10.0089 65.5049 9.94731 65.1361 9.94857C64.6617 9.9441 64.1905 10.0296 63.745 10.201C63.3154 10.371 62.9304 10.6457 62.6214 11.0025C62.2813 11.4052 62.0268 11.8796 61.8748 12.394C61.6969 12.9566 61.6079 13.622 61.6079 14.39V20.0517C61.6079 20.3694 61.4878 20.674 61.2742 20.8986C61.0605 21.1232 60.7707 21.2493 60.4685 21.2493H60.3397C60.0375 21.2493 59.7477 21.1232 59.534 20.8986C59.3203 20.674 59.2003 20.3694 59.2003 20.0517V9.12432C59.2004 8.80683 59.3206 8.50241 59.5342 8.27798C59.7479 8.05355 60.0376 7.92748 60.3397 7.92748V7.92748Z"
                fill="white"
              />
              <path
                d="M76.0855 7.92747H76.2035C76.3538 7.92747 76.5026 7.95859 76.6414 8.01904C76.7803 8.07949 76.9065 8.1681 77.0128 8.2798C77.119 8.3915 77.2033 8.52411 77.2608 8.67006C77.3184 8.816 77.348 8.97243 77.348 9.1304V9.97974H77.4015C77.5637 9.62176 77.7805 9.29403 78.0432 9.0095C78.3093 8.72056 78.6107 8.46999 78.9395 8.26432C79.2804 8.05364 79.645 7.88838 80.0247 7.77236C80.4066 7.6523 80.8031 7.59084 81.2017 7.58987C81.4136 7.58912 81.6251 7.60718 81.834 7.64385C81.9562 7.66743 82.0661 7.73674 82.1434 7.83893C82.2206 7.94112 82.2601 8.06929 82.2543 8.19969L82.1907 9.82918C82.1876 9.90742 82.1685 9.98404 82.1348 10.0539C82.1011 10.1237 82.0535 10.1851 81.9953 10.234C81.9371 10.2829 81.8696 10.318 81.7973 10.3371C81.7251 10.3562 81.6498 10.3588 81.5765 10.3447V10.3447C81.3822 10.3076 81.1851 10.2887 80.9876 10.2885C79.8113 10.2885 78.9108 10.6352 78.2863 11.3287C77.6617 12.0221 77.3496 13.0998 77.3501 14.5618V20.0494C77.3501 20.3685 77.2295 20.6745 77.0149 20.9C76.8003 21.1256 76.5092 21.2524 76.2056 21.2524H76.0877C75.7842 21.2524 75.4931 21.1256 75.2784 20.9C75.0638 20.6745 74.9432 20.3685 74.9432 20.0494V9.1304C74.9432 8.81176 75.0635 8.50613 75.2777 8.28061C75.4918 8.05508 75.7824 7.92808 76.0855 7.92747V7.92747Z"
                fill="white"
              />
              <path
                d="M82.59 3.14875C82.5874 2.90499 82.6323 2.66325 82.7221 2.43844C82.8118 2.21364 82.9443 2.01053 83.1116 1.84166C83.274 1.66806 83.4676 1.53017 83.6811 1.43605C83.8947 1.34193 84.124 1.29346 84.3556 1.29346C84.5872 1.29346 84.8164 1.34193 85.03 1.43605C85.2436 1.53017 85.4372 1.66806 85.5995 1.84166C85.7667 2.01057 85.8992 2.2137 85.9888 2.43851C86.0784 2.66332 86.1232 2.90504 86.1204 3.14875C86.123 3.39244 86.0781 3.63411 85.9885 3.85889C85.899 4.08368 85.7666 4.28682 85.5995 4.45585C85.4372 4.62945 85.2436 4.76733 85.03 4.86145C84.8164 4.95557 84.5872 5.00405 84.3556 5.00405C84.124 5.00405 83.8947 4.95557 83.6811 4.86145C83.4676 4.76733 83.274 4.62945 83.1116 4.45585C82.9445 4.28686 82.812 4.08374 82.7223 3.85896C82.6326 3.63418 82.5876 3.39249 82.59 3.14875V3.14875ZM84.2916 7.92774H84.4196C84.7217 7.92774 85.0114 8.05381 85.225 8.27824C85.4387 8.50267 85.5588 8.80709 85.559 9.12458V20.055C85.559 20.3727 85.439 20.6773 85.2253 20.9019C85.0116 21.1265 84.7218 21.2526 84.4196 21.2526H84.2916C83.9894 21.2526 83.6995 21.1265 83.4859 20.9019C83.2722 20.6773 83.1521 20.3727 83.1521 20.055V9.12458C83.1523 8.80709 83.2724 8.50267 83.4861 8.27824C83.6998 8.05381 83.9895 7.92774 84.2916 7.92774V7.92774Z"
                fill="white"
              />
              <path
                d="M98.8596 21.2526H98.7308C98.4289 21.2522 98.1394 21.1259 97.926 20.9013C97.7127 20.6768 97.5928 20.3724 97.5928 20.055V19.341H97.5393C97.0753 20.0538 96.438 20.6066 95.6272 20.9994C94.8448 21.3865 93.991 21.5881 93.1263 21.5902C92.1453 21.5902 91.2583 21.4128 90.4654 21.058C89.6947 20.719 89.0017 20.2112 88.4326 19.5684C87.8665 18.924 87.4259 18.1695 87.1354 17.3473C86.8254 16.4658 86.6712 15.5322 86.6804 14.5925C86.6721 13.6481 86.8262 12.7099 87.1354 11.8232C87.4219 10.999 87.863 10.2437 88.4326 9.60208C89.0049 8.96675 89.6974 8.46427 90.4654 8.12695C91.2583 7.7721 92.1453 7.59468 93.1263 7.59468C94.0149 7.59089 94.8927 7.79887 95.6938 8.20298C96.4958 8.60852 97.111 9.15675 97.5393 9.84769H97.5928V1.1976C97.5928 0.880239 97.7127 0.575856 97.926 0.351306C98.1394 0.126756 98.4289 0.000402997 98.7308 0L98.8596 0C99.1618 0 99.4516 0.126175 99.6653 0.350769C99.879 0.575362 99.999 0.879976 99.999 1.1976V20.055C99.999 20.3727 99.879 20.6773 99.6653 20.9019C99.4516 21.1265 99.1618 21.2526 98.8596 21.2526V21.2526ZM93.4193 19.2285C94.0148 19.2375 94.6058 19.118 95.1555 18.8772C95.6511 18.6585 96.0974 18.3328 96.4657 17.9214C96.8338 17.4982 97.1161 17.0007 97.2955 16.4592C97.6871 15.2469 97.6871 13.9327 97.2955 12.7204C97.1159 12.1792 96.8336 11.682 96.4657 11.259C96.0974 10.8475 95.6511 10.5219 95.1555 10.3032C94.0394 9.83473 92.7948 9.83473 91.6787 10.3032C91.1828 10.5216 90.7361 10.8473 90.3678 11.259C89.9998 11.6818 89.7177 12.1791 89.5387 12.7204C89.1461 13.9325 89.1461 15.2471 89.5387 16.4592C89.7176 17.0008 89.9997 17.4984 90.3678 17.9214C90.7361 18.3331 91.1828 18.6587 91.6787 18.8772C92.2298 19.1186 92.8223 19.2382 93.4193 19.2285V19.2285Z"
                fill="white"
              />
              <path
                d="M114.396 21.1384C114.407 22.0868 114.239 23.0281 113.901 23.9077C113.582 24.7247 113.103 25.4624 112.496 26.0733C111.864 26.6986 111.118 27.1817 110.302 27.4929C109.394 27.84 108.434 28.0116 107.467 27.9993C106.255 27.9993 105.145 27.8219 104.139 27.467C103.442 27.2157 102.783 26.857 102.186 26.4025C102.061 26.3075 101.956 26.1867 101.877 26.0474C101.797 25.9082 101.746 25.7535 101.726 25.5927C101.706 25.432 101.717 25.2685 101.758 25.1124C101.8 24.9563 101.872 24.8108 101.969 24.6848L102.114 24.4917C102.302 24.2418 102.578 24.0808 102.879 24.0437C103.181 24.0067 103.484 24.0966 103.723 24.294C104.092 24.6076 104.495 24.8748 104.923 25.0901C105.654 25.4556 106.483 25.6383 107.411 25.6383C108.302 25.6383 109.042 25.5025 109.631 25.2308C110.22 24.959 110.689 24.6088 111.04 24.1799C111.385 23.7499 111.635 23.2445 111.772 22.7002C111.915 22.1552 111.988 21.5926 111.989 21.0274V19.0595H111.909C111.469 19.8431 110.811 20.4662 110.024 20.8449C109.24 21.2266 108.387 21.4234 107.523 21.4212C106.638 21.4299 105.761 21.2531 104.942 20.9011C104.174 20.5724 103.478 20.0841 102.895 19.4655C102.317 18.8449 101.862 18.1091 101.558 17.3015C101.232 16.4385 101.068 15.5171 101.076 14.5885C101.07 13.6547 101.224 12.7273 101.531 11.8511C101.819 11.0236 102.26 10.2641 102.828 9.61633C103.397 8.97354 104.09 8.4657 104.861 8.12675C105.654 7.7719 106.541 7.59448 107.522 7.59448C108.387 7.59669 109.24 7.79811 110.023 8.18454C110.834 8.57842 111.472 9.13147 111.935 9.84369H111.989V9.12437C111.989 8.80675 112.109 8.50213 112.322 8.27754C112.536 8.05294 112.826 7.92677 113.128 7.92677H113.257C113.406 7.92677 113.555 7.95775 113.693 8.01793C113.831 8.07812 113.957 8.16633 114.063 8.27754C114.168 8.38875 114.252 8.52077 114.31 8.66607C114.367 8.81137 114.396 8.9671 114.396 9.12437V21.1384ZM107.813 9.95014C107.217 9.94097 106.626 10.0605 106.077 10.3014C105.581 10.5198 105.134 10.8455 104.766 11.2572C104.398 11.6801 104.116 12.1774 103.937 12.7187C103.736 13.3191 103.636 13.9519 103.642 14.5885C103.642 15.9374 104.017 17.0197 104.766 17.8353C105.515 18.6509 106.531 19.0585 107.815 19.058C109.099 19.058 110.115 18.6504 110.864 17.8353C111.613 17.0202 111.987 15.9379 111.987 14.5885C111.993 13.952 111.894 13.3192 111.693 12.7187C111.514 12.1774 111.232 11.6801 110.864 11.2572C110.495 10.8458 110.049 10.5202 109.554 10.3014C109.003 10.0611 108.412 9.94205 107.817 9.95166L107.813 9.95014Z"
                fill="white"
              />
              <path
                d="M117.835 15.5181C117.829 16.0709 117.953 16.6166 118.197 17.1066C118.432 17.5771 118.755 17.9929 119.146 18.3293C119.553 18.6751 120.014 18.9416 120.51 19.1162C121.026 19.3038 121.569 19.3989 122.115 19.3976C122.864 19.3976 123.515 19.2148 124.069 18.8494C124.382 18.6408 124.676 18.4015 124.946 18.1346C125.143 17.9416 125.398 17.8281 125.667 17.8142C125.935 17.8003 126.2 17.8869 126.413 18.0586V18.0586C126.548 18.166 126.658 18.3036 126.735 18.4612C126.813 18.6188 126.856 18.7926 126.861 18.9699C126.867 19.1472 126.835 19.3236 126.768 19.4864C126.701 19.6491 126.6 19.7941 126.473 19.9108C125.243 21.0291 123.684 21.5885 121.796 21.589C120.797 21.589 119.892 21.4116 119.081 21.0567C118.302 20.7244 117.6 20.2212 117.022 19.5808C116.451 18.9398 116.01 18.1843 115.725 17.3598C115.415 16.4733 115.261 15.5354 115.269 14.5912C115.261 13.6431 115.429 12.7024 115.764 11.8219C116.077 10.9957 116.539 10.2411 117.126 9.60008C117.715 8.96586 118.42 8.46399 119.199 8.12494C120.029 7.76372 120.921 7.58267 121.82 7.59268C122.943 7.59268 123.892 7.79874 124.668 8.21087C125.41 8.596 126.063 9.14786 126.581 9.82744C127.081 10.4941 127.45 11.2587 127.666 12.0766C127.888 12.9046 128 13.7607 128 14.6209C128 14.8594 127.91 15.0882 127.749 15.2569C127.589 15.4256 127.371 15.5204 127.144 15.5204L117.835 15.5181ZM125.431 13.494C125.419 12.9684 125.333 12.4475 125.177 11.9481C125.033 11.4947 124.801 11.078 124.495 10.7247C124.178 10.3684 123.79 10.0901 123.358 9.90956C122.851 9.70276 122.311 9.60253 121.767 9.61453C121.21 9.60772 120.657 9.72755 120.148 9.96583C119.682 10.1826 119.259 10.4925 118.905 10.8783C118.573 11.2422 118.306 11.6659 118.116 12.1291C117.935 12.5586 117.839 13.0226 117.835 13.4925L125.431 13.494Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
      </div>

      <!-- search bar -->
      <form
        v-if="
          routeType === 'General' ||
          routeType === 'Product by category' ||
          routeType === 'All Items'
        "
        @submit="handleSearchSubmit"
        class="sm:flex mx-6 flex-1 items-center justify-between hidden"
      >
        <div
          class="cursor-pointer flex flex-shrink-0 items-center justify-between text-sm text-white bg-gray-700 border-2 border-gray-600 rounded-md rounded-r-none focus:outline-none"
        >
          <SearchList
            v-on:change="handleSearchOption"
            :options="searchOptions"
          />
        </div>
        <div
          class="relative px-3 py-2 w-full flex items-center justify-between bg-gray-800 border-2 border-l-0 border-gray-600 rounded-md rounded-l-none"
        >
          <input
            ref="searchField"
            class="w-full placeholder-gray-500 text-sm text-white bg-gray-800 focus:outline-none"
            type="text"
            @input="handleInput"
            @focus="showSuggestion = true"
            @blur="showSuggestion = false"
            @keydown="handleKeyPress"
            @keypress.enter="handleSuggestionSelect"
            placeholder="search..."
            v-model="searchQuery"
          />
          <button
            type="submit"
            class="text-gray-300 focus:outline-none focus:text-white"
          >
            <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <!-- suggestion -->
          <Transition
            enter-active-class="transition duration-100"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              ref="suggestions"
              v-if="
                getSuggestions.length > 0 &&
                searchQuery.length > 0 &&
                showSuggestion
              "
              class="absolute py-2 mt-9 z-30 w-full bg-extraDarkOverlay border-t-2 border-gray-600 rounded-md rounded-t-none top-0 right-0 shadow flex flex-col divide-y divide-gray-600 overflow-hidden"
            >
              <router-link
                :to="{
                  name: searchSelectedOption.split('-').join(' '),
                  params: { ...$route.params, page: '' },
                  query: {
                    ...$route.query,
                    search: suggestion,
                  },
                }"
                v-for="suggestion in getSuggestions"
                :key="suggestion"
                :class="
                  selectedSugestion &&
                  selectedSugestion === suggestion.toLowerCase()
                    ? 'bg-lightDarkOverlay '
                    : 'bg-transparent'
                "
                class="px-3 py-2 w-full text-left block text-sm text-white hover:bg-lightDarkOverlay"
              >
                <span>{{ searchQuery || "" }}</span>
                <strong>{{
                  searchQuery &&
                  suggestion
                    .toLowerCase()
                    .slice(
                      suggestion
                        .toLowerCase()
                        .search(searchQuery.toLowerCase()) + searchQuery.length,
                      suggestion.length
                    )
                }}</strong>
              </router-link>
            </div>
          </Transition>
        </div>
      </form>

      <!-- links -->
      <div
        v-if="
          routeType === 'General' ||
          routeType === 'Product by category' ||
          routeType === 'All Items'
        "
        class="space-x-6 xl:flex items-center justify-center hidden"
      >
        <router-link
          v-for="primaryLink in primaryLinks"
          :key="primaryLink.id"
          class="px-2 py-1 focus:font-semibold focus:text-white hover:text-white text-gray-300 text-sm focus:bg-gray-800 hover:bg-gray-800 rounded-md focus:outline-none"
          :class="primaryLink.isActive ? 'bg-gray-800' : 'bg-gray-900'"
          :to="`${primaryLink.url}/sort-by-new`"
          >{{ primaryLink.title }}
        </router-link>
        <router-link
          v-if="
            !getCurrentUser ||
            (getCurrentUser && getCurrentUser.subscription === 'free')
          "
          class="px-2 py-1 focus:font-semibold focus:text-white hover:text-white text-gray-300 text-sm focus:bg-gray-800 hover:bg-gray-800 rounded-md focus:outline-none"
          to="/pricing"
        >
          Pricing
        </router-link>
      </div>

      <!-- signup and login -->
      <div class="ml-6 space-x-3 md:space-x-6 flex flex-shrink-0 items-center">
        <a
          v-if="
            (routeType === 'General' ||
              routeType === 'Product by category' ||
              routeType === 'All Items') &&
            !getCurrentUser
          "
          href="/register"
          class="px-2 py-2 md:px-3 md:py-2 font-semibold text-center text-gray-900 text-xs md:text-sm bg-brandGreen transition-colors duration-300 hover:bg-brandGreenHover rounded-md focus:outline-none focus:ring-2 focus:ring-brandGreen focus:ring-offset-2 focus:ring-offset-gray-900"
        >
          <span class="lg:block hidden">Create a free account</span>
          <span class="lg:hidden block">Sign up</span>
        </a>
        <router-link
          to="/pricing"
          v-if="
            routeType === 'login' ||
            routeType === 'forgotPassword' ||
            (getCurrentUser && getCurrentUser.subscription === 'free')
          "
          class="hidden md:block px-2 py-2 md:px-3 md:py-2 font-semibold text-center text-white text-xs md:text-sm bg-buttonColor transition-colors duration-300 hover:bg-pink-700 rounded-md focus:outline-none focus:ring-2 focus:ring-buttonColor focus:ring-offset-2 focus:ring-offset-gray-900"
        >
          <span class="">Get unlimited Downloads</span>
        </router-link>
        <router-link
          to="/pricing"
          v-if="
            routeType === 'login' ||
            routeType === 'forgotPassword' ||
            (getCurrentUser && getCurrentUser.subscription === 'monthly')
          "
          class="hidden md:block px-2 py-2 md:px-3 md:py-2 font-semibold text-center text-white text-xs md:text-sm bg-buttonColor transition-colors duration-300 hover:bg-pink-700 rounded-md focus:outline-none focus:ring-2 focus:ring-buttonColor focus:ring-offset-2 focus:ring-offset-gray-900"
        >
          <span class="">Upgrade to Annual</span>
        </router-link>
        <a
          v-if="!getCurrentUser"
          href="/login"
          class="space-x-2 flex items-center group focus:outline-none rounded-md hover:bg-gray-700 px-2 py-2 focus:bg-gray-700"
          :class="
            $route.name === 'login' || $route.name === 'register'
              ? 'hidden md:flex'
              : 'flex'
          "
        >
          <span
            class="h-5 w-5 md:h-5 md:w-5 flex items-center bg-gray-100 rounded-full overflow-hidden"
            ><svg
              class="-mb-1 md:-mb-2 h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                clip-rule="evenodd"
              /></svg
          ></span>
          <span class="font-medium text-xs md:text-sm text-white">Sign in</span>
        </a>

        <Menu
          as="div"
          v-if="getCurrentUser"
          class="relative focus:outline-none"
        >
          <MenuButton
            as="button"
            class="space-x-2 text-sm flex items-center group focus:outline-none rounded-md hover:bg-gray-700 px-2 py-2 focus:bg-gray-700 text-white"
          >
            <span class="max-w-xxxs truncate"
              >{{ getCurrentUser.userName }} test</span
            >
            <span
              v-if="!getCurrentUser.profile"
              class="h-5 w-5 flex items-center bg-gray-100 rounded-full overflow-hidden"
              ><svg
                class="-mb-1 md:-mb-2 h-5 w-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                  clip-rule="evenodd"
                /></svg
            ></span>
            <span
              v-else
              class="w-5 h-5 flex items-center bg-gray-100 rounded-full overflow-hidden"
            >
              <img
                :src="getCurrentUser.profile"
                alt="users profile"
                class="w-full h-full object-cover overflow-hidden"
              />
            </span>
            <svg
              class="h-5 w-5 md:h-5 md:w-5 text-gray-100"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
              />
            </svg>
          </MenuButton>
          <Transition
            enter-active-class="transition duration-100"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <MenuItems
              as="div"
              class="absolute w-44 flex flex-col items-start gap-2 pt-3 z-20 right-0 mt-1 bg-extraDarkOverlay shadow rounded-md focus:outline-none"
            >
              <router-link class="focus:outline-none" to="/downloads">
                <MenuItem v-slot="{ active }">
                  <span
                    class="w-full text-left block mx-3 px-3 py-2 rounded-md text-sm text-white transition duration-100 focus:outline-none"
                    :class="{ 'bg-lightDarkOverlay': active }"
                    >My Downloads</span
                  >
                </MenuItem>
              </router-link>
              <router-link class="focus:outline-none" to="/collections">
                <MenuItem v-slot="{ active }">
                  <span
                    class="w-full text-left block mx-3 px-3 py-2 rounded-md text-sm text-white transition duration-100 focus:outline-none"
                    :class="{ 'bg-lightDarkOverlay': active }"
                    >My Collections</span
                  >
                </MenuItem>
              </router-link>

              <router-link class="focus:outline-none" to="/account">
                <MenuItem v-slot="{ active }">
                  <span
                    class="w-full text-left block mx-3 px-3 py-2 rounded-md text-sm text-white transition duration-100 focus:outline-none"
                    :class="{ 'bg-lightDarkOverlay': active }"
                    >My Account</span
                  >
                </MenuItem>
              </router-link>

              <a class="focus:outline-none" href="https://account.exvaxo.com">
                <MenuItem v-slot="{ active }">
                  <span
                    class="w-full text-left block mx-3 px-3 py-2 rounded-md text-sm text-white transition duration-100 focus:outline-none"
                    :class="{ 'bg-lightDarkOverlay': active }"
                    >Settings</span
                  >
                </MenuItem>
              </a>

              <MenuItem v-slot="{ active }">
                <button
                  @click="handleLogOut"
                  class="w-full block text-center bg-lightDarkOverlay px-3 py-3 rounded-md text-sm text-white transition duration-100 focus:outline-none"
                  :class="{ 'bg-lightDarkOverlay': active }"
                >
                  Log out
                </button>
              </MenuItem>
            </MenuItems>
          </Transition>
        </Menu>
      </div>
    </nav>

    <!-- search bar for mobile -->
    <form
      v-if="
        routeType === 'General' ||
        routeType === 'Product by category' ||
        routeType === 'All Items'
      "
      @submit="handleSearchSubmit"
      class="w-full px-4 pb-4 flex-1 flex items-center justify-between sm:hidden"
    >
      <div
        class="cursor-pointer flex flex-shrink-0 items-center justify-between text-sm text-white bg-gray-700 border-2 border-gray-600 rounded-md rounded-r-none focus:outline-none"
      >
        <SearchList v-on:change="handleSearchOption" :options="searchOptions" />
      </div>
      <div
        class="relative px-3 py-2 w-full flex items-center justify-between bg-gray-800 border-2 border-l-0 border-gray-600 rounded-md rounded-l-none"
      >
        <input
          ref="searchField"
          class="w-full placeholder-gray-500 text-sm text-white bg-gray-800 focus:outline-none"
          type="text"
          placeholder="search..."
          @input="showSuggestion = true"
          @focus="showSuggestion = true"
          @blur="showSuggestion = false"
          @keydown="handleKeyPress"
          @keypress.enter="handleSuggestionSelect"
          v-model="searchQuery"
        />
        <button
          type="submit"
          class="text-gray-300 focus:outline-none focus:text-white"
        >
          <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clip-rule="evenodd"
            />
          </svg>
        </button>

        <!-- suggestion -->
        <div class="absolute top-0 right-0 mt-12 z-30 px-4 w-full">
          <Transition
            enter-active-class="transition duration-100"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              ref="suggestions"
              v-if="
                getSuggestions.length > 0 &&
                searchQuery.length > 0 &&
                showSuggestion
              "
              class="absolute py-2 -mt-3 z-30 w-full bg-extraDarkOverlay border-t-2 border-gray-600 rounded-md rounded-t-none top-0 right-0 shadow flex flex-col divide-y divide-gray-600 overflow-hidden"
            >
              <router-link
                :to="{
                  name: searchSelectedOption.split('-').join(' '),
                  params: { ...$route.params, page: '' },
                  query: {
                    ...$route.query,
                    search: suggestion,
                  },
                }"
                v-for="suggestion in getSuggestions"
                :key="suggestion"
                :class="
                  selectedSugestion &&
                  selectedSugestion === suggestion.toLowerCase()
                    ? 'bg-lightDarkOverlay '
                    : 'bg-transparent'
                "
                class="px-3 py-2 w-full text-left block text-sm text-white hover:bg-lightDarkOverlay"
              >
                <span>{{ searchQuery || "" }}</span>
                <strong>{{
                  searchQuery &&
                  suggestion
                    .toLowerCase()
                    .slice(
                      suggestion
                        .toLowerCase()
                        .search(searchQuery.toLowerCase()) + searchQuery.length,
                      suggestion.length
                    )
                }}</strong>
              </router-link>
            </div>
          </Transition>
        </div>
      </div>
    </form>

    <!-- sub navigation -->
    <header
      v-if="
        routeType === 'General' ||
        routeType === 'Product by category' ||
        routeType === 'All Items'
      "
      class="hidden text-xs md:text-sm w-full md:flex items-center justify-center bg-gray-700 shadow"
    >
      <div
        class="w-full xl:-ml-5 max-w-1xl px-4 2xl:px-0 xl:gap-2 flex items-center justify-start"
      >
        <!--   -->
        <router-link
          v-for="productLink in productLinks"
          :key="productLink.id"
          @mouseenter="handleMouseEnter(productLink.value)"
          @mouseleave="handleMouseLeave(productLink.value)"
          class="relative focus:font-semibold md:px-2 2xl:px-0 py-3 focus:text-white hover:text-white border-b border-gray-700 hover:border-gray-200 text-gray-300 focus:outline-none flex-shrink-0 transition duration-300"
          :to="productLink.url"
        >
          <span class="px-3">{{ productLink.title }}</span>
          <!-- dropdown -->
          <Transition
            enter-active-class="transition duration-100"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              v-if="showSub[productLink.value] && productLink.value"
              style="margin-top: 45px"
              :class="productLink.value === 'addOns' ? 'w-48' : 'w-96'"
              class="absolute -ml-8 top-0 left-0 border-t border-gray-900 border-opacity-30 shadow rounded-t-none bg-extraDarkOverlay rounded-md"
            >
              <div
                :class="
                  productLink.value === 'addOns' ? 'grid-cols-1' : 'grid-cols-2'
                "
                class="w-full grid gap-5 p-5"
              >
                <div
                  v-for="category in getCategory[productLink.value]"
                  :key="category.id"
                  class=""
                >
                  <router-link
                    v-if="category.title"
                    :to="category.url.toLowerCase()"
                    class="max-w-min px-3 py-2 rounded-md rounded-l-none border-l-2 border-transparent hover:border-brandPurple text-xs hover:bg-lightDarkOverlay text-white whitespace-nowrap"
                    >{{ category.title }}</router-link
                  >
                </div>
              </div>
              <router-link
                :to="productLink.url"
                class="relative flex items-center justify-center bottom-0 rounded-b-md w-full bg-lightDarkOverlay py-4 col-span-2 text-center text-xs text-white hover:text-gray-200"
              >
                All {{ productLink.realTitle
                }}<svg
                  class="ml-2 w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </router-link>
            </div>
          </Transition>
        </router-link>
      </div>

      <!-- <div
				class="md:px-6 px-4 py-3 xl:hidden space-x-5 lg:space-x-12 flex items-center justify-end bg-gray-600 "
			>
				<router-link
					v-for="primaryLink in primaryLinks"
					:key="primaryLink.id"
					class="focus:font-semibold focus:text-white hover:text-white text-gray-300 focus:outline-none"
					:to="primaryLink.url"
					>{{ primaryLink.title }}
				</router-link>
			</div>  -->
    </header>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import SearchList from "./SearchList.vue";
import Sidebar from "./Sidebar.vue";
export default {
  name: "Topbar",
  components: { SearchList, Sidebar, Menu, MenuButton, MenuItems, MenuItem },

  computed: {
    ...mapGetters(["getCurrentUser"]),
    ...mapGetters(["primaryLinks"]),
    ...mapGetters(["productLinks"]),
    ...mapGetters(["searchOptions"]),
    ...mapGetters(["getCategory"]),
    ...mapGetters(["getSuggestions"]),
  },

  methods: {
    ...mapActions(["setSearchQuery"]),
    ...mapActions(["setSearchOption"]),
    ...mapActions(["fetchSuggestions"]),
    ...mapActions(["fetchAvailableCollections"]),
    ...mapActions(["logout"]),
    ...mapActions(["getCurrentUser"]),

    handleInput() {
      this.showSuggestion = true;
      this.selectedSugestion = null;
    },

    handleSuggestionSelect() {
      let query = {};
      if (this.selectedSugestion && this.searchQuery.length > 0) {
        query.search = this.selectedSugestion;
      } else if (!this.selectedSugestion && this.searchQuery.length > 0) {
        query.search = this.searchQuery.trim();
      } else {
        delete query.search;
      }

      this.$router.push({
        name: this.searchSelectedOption.toLowerCase().split("-").join(" "),
        params: { ...this.$route.params, page: "" },
        query,
        hash: this.$route.hash,
      });
      this.showSuggestion = false;
    },
    handleKeyPress(e) {
      if (e.keyCode === 40) {
        if (this.currentIndex < this.suggestions.length) {
          this.currentIndex++;
        } else {
          this.currentIndex = 1;
        }
        this.selectedSugestion =
          this.$refs.suggestions.children[this.currentIndex - 1].outerText;
      }
      if (e.keyCode === 38) {
        if (this.currentIndex > 1) {
          this.currentIndex--;
        } else {
          this.currentIndex = this.suggestions.length;
        }
        this.selectedSugestion =
          this.$refs.suggestions.children[this.currentIndex - 1].outerText;
      }
    },

    handleMouseEnter(e) {
      this.showSub[e] = true;
    },

    handleMouseLeave(e) {
      this.showSub[e] = false;
    },

    handleLogOut() {
      this.logout();
    },

    handleSearchSubmit(e) {
      e.preventDefault();
      this.setSearchQuery(this.searchQuery);
      this.setSearchOption(this.searchSelectedOption);
      let query = {};
      if (this.selectedSugestion && this.searchQuery.length > 0) {
        query.search = this.selectedSugestion;
        localStorage.setItem("search", this.selectedSugestion);
      } else if (!this.selectedSugestion && this.searchQuery.length > 0) {
        localStorage.setItem("search", this.searchQuery.trim());
        query.search = this.searchQuery.trim();
      } else {
        delete query.search;
      }

      this.$router.push({
        name: this.searchSelectedOption.toLowerCase().split("-").join(" "),
        params: { ...this.$route.params, page: "" },
        query,
        hash: this.$route.hash,
      });
    },

    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },

    handleSearchOption(e) {
      if (e) {
        this.searchSelectedOption = e.value;
      }
    },
  },

  mounted() {
    if (this.getCurrentUser) {
      this.fetchAvailableCollections();
    }

    if (this.$route.query.search && this.$route.name !== "ContributorProfile") {
      this.searchQuery = this.$route.query.search;
      this.setSearchOption(this.searchOptions[0].value);
      this.searchSelectedOption = this.searchOptions[0].value;
    }
  },
  data() {
    return {
      suggestions: [],
      currentIndex: 0,
      selectedSugestion: null,

      isSidebarOpen: false,
      searchQuery: "",
      searchSelectedOption: "all items",
      routeType: "General",
      showSuggestion: false,
      showSub: {
        afterEffectsTemplates: false,
        premiereProTemplates: false,
        soundEffects: false,
        addOns: false,
        music: false,
        stockFootage: false,
        motionGraphics: false,
      },
    };
  },
  watch: {
    $route(to, from) {
      this.isSidebarOpen = false;
      window.scrollTo({
        top: 0,
        left: 0,
      });

      if (this.getCurrentUser) {
        this.fetchAvailableCollections();
      }

      if (to.name !== "ContributorProfile") {
        if (to.query.search) {
          this.searchQuery = to.query.search.toLowerCase().split("+").join(" ");
        } else {
          this.searchQuery = "";
          this.selectedSugestion = null;
        }
      }
    },
    searchQuery: function (nv) {
      if (nv.length > 0) {
        this.fetchSuggestions({
          query: nv,
          category: this.searchSelectedOption,
        });
      }
    },
    getSuggestions: function (nv) {
      this.suggestions = nv;
    },

    getCurrentUser: function (newVal, oldVal) {
      if (oldVal && !newVal) {
        this.getCurrentUser = null;
      } else {
        this.getCurrentUser = oldVal;
      }
    },
  },
};
</script>

<style scoped>
.t {
  background: #404040fd;
}
</style>
